<template>
	<!-- 业务权限 -->
	<div class="tree-container">
		<el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
			:modal-append-to-body="false" width="35%">
			<div class="dialog-input flex flex-middle" slot="title">
				<label class="f14 font-weight-bold mr5">业务权限</label>
			</div>

			<el-tree
				:data="treeData"
				show-checkbox
				node-key="mbCode"
				ref="tree"
				:check-strictly="false"
				:props="defaultProps"
				@check="handleCheck"
				class="tree-box mt10">
				<span class="custom-tree-node" slot-scope="{ node, data }">
					<span>
						<i class="el-icon-menu"></i>
						{{data.menuName}}
					</span>
				</span>
			</el-tree>
			<div class="flex flex-center mt20">
				<el-button  size="small" class="save-btn" type="primary" @click="submit()">确定</el-button>
			</div>
		</el-dialog>
		<!--选择成员弹出 end-->
	</div>
</template>
<script>
	export default {
		name: "ReportMember",
		data() {
			return {
				dialogVisible: false,
				treeData: [],
				defaultProps: {
					children: "children",
					label: "menuName"
				},
				filterData: [],
				selectTreeKey:[],
				selectUser:[],
			};
		},

		methods: {
			// 显示弹窗
			init(selectUser) {
				this.dialogVisible = true;
				this.getMenuTree();
				this.$nextTick(() => {
					if (selectUser.length>0) {
						this.selectUser=selectUser
						// this.$refs.tree.setCheckedKeys(selectUser)
					}else {
						this.selectUser=['m_index']
						// this.$refs.tree.setCheckedKeys([])
					}
				})
			},
			// 获取菜单树
			getMenuTree() {
				let that = this;
				that.$request.post(
					"menuTree",
					true, {}
				)
				.then((res) => {
					if (res) {
						that.treeData = res.data;
						res.data[0].disabled=true
						that.$refs.tree.setCheckedKeys(that.selectUser)
					}
				})
			},
			handleCheck(data,nodes) {
				// this.selectTreeKey = []
				// this.selectTreeKey=[...nodes.halfCheckedKeys,...nodes.checkedKeys]
				// // 当前菜单mbcode
				// let cmbcode = data.mbCode;
				// // 所有选中节点的id
				// let allKeys = nodes.checkedKeys;
				// let allNodes = nodes.checkedNodes;
				// // 当前菜单是否被选中，选中true,取消false
				// let checkedKey = allKeys.includes(cmbcode);
				// // 父菜单
				// if(data.children) {
				// 	let childrenNodes = data.children;
				// 	// 父菜单被选中子菜单全选
				// 	if(checkedKey) {
				// 		let addArr = [];
				// 		let addChildArr = [];
				// 		childrenNodes.forEach(item => {
				// 			// 二级
				// 			addChildArr.push(item.mbCode)
				// 			if(item.children){
				// 				item.children.forEach(child => {
				// 					// 三级
				// 					addChildArr.push(child.mbCode)
				// 					if(child.children) {
				// 						child.children.forEach(son => {
				// 							// 四级
				// 							addChildArr.push(son.mbCode)
				// 						})
				// 					}
				// 				})
				// 			}
				// 		});
				// 		addArr = [...addChildArr,...allKeys];
				// 		this.$refs.tree.setCheckedKeys(Array.from(new Set(addArr)));
				// 	}
				// 	// 父菜单勾除子菜单同时勾除
				// 	else{
				// 		let childrenNodes = data.children;
				// 		let deleteChildArr = [];
				// 		childrenNodes.forEach(item => {
				// 			// 二级
				// 			deleteChildArr.push(item.mbCode)
				// 			if(item.children){
				// 				item.children.forEach(child => {
				// 					// 三级
				// 					deleteChildArr.push(child.mbCode)
				// 					if(child.children) {
				// 						child.children.forEach(son => {
				// 							// 四级
				// 							deleteChildArr.push(son.mbCode)
				// 						})
				// 					}
				// 				})
				// 			}
				// 		});
				// 		let deleteKeys = [];
				// 		allKeys.forEach(item => {
				// 			if(!deleteChildArr.includes(item)) {
				// 				deleteKeys.push(item);
				// 			}
				// 		})
				// 		this.$refs.tree.setCheckedKeys(Array.from(new Set(deleteKeys)));
				// 	}
				// }
			},
			// 保存
			submit() {
				let keys = {
					keys:this.$refs.tree.getCheckedKeys(),//全选
					halfkeys:this.$refs.tree.getHalfCheckedKeys(),//半选
				}
				this.$emit('permissionsListener', keys);
				this.dialogVisible = false;
			}
		}
	};

</script>

<style lang="scss" scoped>
	.tree-container {
		/deep/ .el-dialog__body {
			padding: 15px 20px;
		}
	}

	.el-tree {
		height: 360px;
		overflow: auto;
	}

</style>
